import ClassChoose from './ClassChoose';

export default ClassChoose;
export { ClassChoose };
